import React from 'react'
import Android from '../assets/img/app_download/icon_playstore.svg'
import Apple from '../assets/img/app_download/icon_appstore.svg'
import WindowsOS from '../assets/img/app_download/icon_windowsos.svg'
import MacsOS from '../assets/img/app_download/icon_macos.svg'
import Windows from '../assets/img/app_download/windows.svg'
import Mac from '../assets/img/app_download/mac.svg'
import {Modal} from 'antd';
import {desktopAppUrl} from "../config";

// href={"https://careerdose.com/downloads/CareerDose%20Setup%201.0.0.exe"} target={"download"}

class Applink extends React.Component {
    state = {
        windows: false,
        soon: false,
        oswindows: false,
        url: ''
    };

    constructor(props) {
        super(props);
        fetch(desktopAppUrl).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    this.setState({
                        url: data['url']
                    })
                })
            }
        })
    }

    windows(windows) {
        this.setState({windows});
    }

    soon(soon) {
        this.setState({soon});
    }

    oswindows(oswindows) {
        this.setState({oswindows});
    }

    resetModal() {
        this.setState({
            soon: false,
            oswindows: false,
        });
    }

    render() {
        return (
            <>
                <div className="app-download-link mb-2">
                    <a href={"https://play.google.com/store/apps/details?id=com.careerdose.learning"} className="btn p-0" target="_blank" rel="noopener noreferrer">
                        <img loading="lazy" src={Android} className="img-fluid" alt="android_app_link"/>
                    </a>
                    <a className="btn p-0" href={this.state.url} download>
                        <img loading="lazy" src={WindowsOS} className="img-fluid" alt="windows_app_link"/>
                    </a>
                </div>
                <div className="app-download-link">

                </div>
                <Modal
                    title={null}
                    centered
                    visible={this.state.windows}
                    onOk={() => this.windows(false)}
                    onCancel={() => this.windows(false)}
                    mask
                    maskClosable
                    footer={null}
                    className="p-4"
                >
                    <div className="row">
                        <div className={"col-lg-6 col-md-6 col-sm-12 mb-5 mb-md-0"}>
                            <img loading="lazy" src={Windows} style={{width: 64}} alt="windows_app_link"/>
                            <div className="mt-2">
                                <p className="font-weight-bold h4 mb-0">Career Dose Desktop App for</p>
                                <p className="font-weight-bold h1 cd-blue-text">Maths & Science</p>
                                <button className="btn cd-primary-gradient border-0 font-weight-bold letter-space text-white">Download Now</button>
                            </div>
                        </div>
                        <div className={"col-lg-6 col-md-6 col-sm-12"}>
                            <img loading="lazy" src={Windows} style={{width: 64}} alt="windows_app_link"/>
                            <div className="mt-2">
                                <p className="font-weight-bold h4 mb-0">Career Dose Player for</p>
                                <p className="font-weight-bold h1 cd-red-text">French</p>
                                <button className="btn cd-danger-gradient border-0 font-weight-bold letter-space text-white">Download Now</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    title={null}
                    centered
                    visible={this.state.soon}
                    onOk={() => this.soon(false)}
                    onCancel={() => this.soon(false)}
                    mask
                    maskClosable
                    footer={null}
                    className="p-4"
                >
                    <p className="display-5 font-weight-bold cd-red-text">Comming Soon</p>
                    <h2 className="h2">The Application you've been waiting for is getting ready & will launch very soon.</h2>
                </Modal>
            </>
        );
    }
}

export default Applink
